import { render, staticRenderFns } from "./HelpPop.vue?vue&type=template&id=3c4e2d42&scoped=true"
import script from "./HelpPop.vue?vue&type=script&lang=js"
export * from "./HelpPop.vue?vue&type=script&lang=js"
import style0 from "./HelpPop.vue?vue&type=style&index=0&id=3c4e2d42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4e2d42",
  null
  
)

export default component.exports